var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-section"},[_c('div',[_c('keep-alive',[_c(_vm.currentStage,{tag:"PhoneLogin",on:{"authCodeDidSend":_vm.authCodeWasSent}}),_c(_vm.currentStage,{tag:"LoginVerificationCode",on:{"authCodeDidSend":_vm.authCodeWasSent}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }